import { defaultBaseBackgroundRenderContribution } from "./base-contribution-render";

import { defaultBaseTextureRenderContribution } from "./base-texture-contribution-render";

export const defaultPolygonTextureRenderContribution = defaultBaseTextureRenderContribution;

export const defaultPolygonBackgroundRenderContribution = defaultBaseBackgroundRenderContribution;
//# sourceMappingURL=polygon-contribution-render.js.map
